import { createApiInstance } from '@/utilities/api/create-instance';
import { InstanceType } from '@/utilities/api/enums/instance-type.enum';

export const datastreamApi = createApiInstance(InstanceType.Datastream);
